import { useEffect } from "react";
import { usePageTitle } from "hooks/usePageTitle";
import { SearchBar } from "modules/main/components/searchBar";
import { PageBreadcrumbs } from "modules/main/components/page-breadcrumbs";

const CatalogEntry = () => {
  const { setTitle, setBreadcrumb, setShowBack } = usePageTitle();

  useEffect(() => {
    setTitle("Catálogo");
    // EXTENSION 8: breadcrumb routes must never show the stale ArrowLeft a
    // previous route left behind — defensively reset the global back arrow.
    setShowBack(false);
    setBreadcrumb(
      <PageBreadcrumbs
        crumbs={[
          { label: "Inicio", to: "/store" },
          { label: "Catálogo" },
        ]}
      />,
    );
    return () => setBreadcrumb(null);
  }, [setTitle, setBreadcrumb, setShowBack]);

  return (
    <main className="flex flex-col items-center justify-center gap-6 py-8 px-4">
      <p className="text-muted-foreground text-center max-w-md">
        Encuentra los mejores productos y ahorra en tus compras
      </p>
      <SearchBar className="w-full max-w-xl" />
    </main>
  );
};

export default CatalogEntry;
